import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../localization/labels";
import { falseFilter, selectFilter } from "../../../../services/FilteringUtils";
import PartyMessageService from "../../../../services/PartyMessageService";
import PartySession from "../../../../session/PartySession";
import CommonUtil from "../../../../utils/CommonUtil";
import PathUtil from "../../../../utils/PathUtil";
import withRouterAndRef from "../../../core/withRouterAndRef";
import { paths } from "../../../paths";
import PageComponent from "../PageComponent";
import NotificationBadge from "./NotificationBadge";

class NotificationBadgeContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.partyMessageService = new PartyMessageService(this.keycloak);
    this.state = {};
    this.notificationBadgeRefreshPropagator =
      props.notificationBadgeRefreshPropagator;
  }

  getComponentTitle = () => {
    return labels.partyMessagesTitle;
  };

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
    this.notificationBadgeRefreshPropagator(this.reload);
  }

  onAllMessagesClick = () => {
    this.changePath(paths.PARTY_MESSAGES, labels.partyMessagesTitle);
  };

  loadData = () => {
    const pageInfo = {
      size: 3,
      filters: {
        read: falseFilter,
        partyId: selectFilter(PartySession.getPartyId())
      }
    };
    const sortInfo = { orderBy: "dispatchDate", direction: "desc" };
    this.prepareCall(
      this.partyMessageService.getEntities(
        pageInfo,
        sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDataLoad = data => {
    const totalElements = data?.page?.totalElements || 0;
    const messages = CommonUtil.getDataContent(data) || [];
    this.setState({
      numberOfMessages: totalElements,
      messages: messages
    });
  };

  onMessageClick = id => {
    const path = PathUtil.itemPath(
      PathUtil.jointPath(paths.PARTY_MESSAGES, paths.DETAIL),
      id
    );
    this.changePath(path, labels.partyMessagesTitle);
  };

  reload = () => {
    this.loadData();
  };

  openInNewTab = e => {
    window.open(paths.PARTY_MESSAGES, "_blank", "noopener");
  };

  render() {
    return (
      <NotificationBadge
        count={this.state.numberOfMessages}
        messages={this.state.messages}
        onAllMessagesClick={this.onAllMessagesClick}
        onMessageClick={this.onMessageClick}
        openInNewTab={this.openInNewTab}
        containerRef={this.props.containerRef}
      />
    );
  }
}

export default withRouterAndRef(withKeycloak(NotificationBadgeContainer));
